export const STORAGE_USERINFO = 'STORAGE_USERINFO';        //用户信息
export const LOADING='LOADING';            //loading
export const RECORDED='RECORDED';
export const VIDEOURL='VIDEOURL';          //视频url
export const WXSHARE='WXSHARE';            //微信分享
export const RECORDING='RECORDING';         //录播
export const MEETING_ID='MEETING_ID';         //会议id


// WEBPACK FOOTER //
// ./src/store/mutation-types.js